import { defaultZodCatch } from '@/lib/converters/defaultZodCatch'
import { discountAppliedConverter } from '@/lib/converters/discountApplied/discountAppliedConverter'
import { discountRowTypeEnumConverter } from '@/lib/converters/discountRowTypeEnum/discountRowTypeEnumConverter'
import { priceTypeEnum2Converter } from '@/lib/converters/prices/priceTypeEnum2/priceTypeEnum2Converter'
import { smallestUnitPriceConverter } from '@/lib/converters/smallestUnitPrice/smallestUnitPriceConverter'
import { zPriceValue } from '@/schemas/priceValueSchema'

import type { PriceValueDto as ResponseDto } from '@/gen/bff'
import type { PriceValueSchema } from '@/schemas/priceValueSchema'

export const priceValueConverter = (data: ResponseDto): PriceValueSchema => {
  const response: PriceValueSchema = {
    value: data.value ?? 0,
    valueWithVat: data.valueWithVat ?? 0,
    totalValue: data.totalValue ?? 0,
    totalValueWithVat: data.totalValueWithVat ?? 0,
    fullValue: data.fullValue ?? 0,
    fullValueWithVat: data.fullValueWithVat ?? 0,
    fullTotalValue: data.fullTotalValue ?? 0,
    fullTotalValueWithVat: data.fullTotalValueWithVat ?? 0,
    discountAppliedId: data.discountAppliedId ?? null,
    priorityPrice: data.priorityPrice ?? false,
    priceType: priceTypeEnum2Converter(data.priceType),
    discountRowType: discountRowTypeEnumConverter(data.discountRowType),
    smallestUnitPrice: smallestUnitPriceConverter(data.smallestUnitPrice),
    discountApplied:
      data.discountApplied != null && data.discountApplied?.length > 0
        ? data.discountApplied.map(discountAppliedConverter)
        : null,
    quantity: data.quantity ?? 1,
  }

  return zPriceValue.catch(defaultZodCatch).parse(response)
}
